<template>
  <div class="flex flex-row-reverse justify-center items-center cursor-pointer gap-[8px] relative">
    <p
        :class="disabled ? 'text-grays-600' : ''"
        class="text-sm text-grays-800 font-medium"
    >
      <slot></slot>
    </p>
    <div class="w-[28px] h-[28px] flex justify-center items-center text-primary-700">
      <input
          :checked="isChecked"
          :disabled="disabled || shouldPreventUncheck"
          class="appearance-none absolute w-full h-full top-0 left-0 cursor-pointer"
          type="checkbox"
          @change="updateCheckbox"
      />
      <span
          v-if="!isChecked"
          :class="disabled ? 'text-grays-600' : ''"
          class="material-symbols-rounded w-[21px] h-[21px] text-[21px]"
      >
        check_box_outline_blank
      </span>
      <span
          v-else
          :class="disabled ? 'text-grays-600' : ''"
          class="material-symbols-rounded w-[21px] h-[21px] text-[21px]"
      >
        check_box
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "check-box-by-numbers",
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: Object,
      required: true,
    },
    preventUncheck: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateCheckbox() {
      const newValue = this.modelValue === 1 ? 0 : 1;
      this.$emit("update:modelValue", newValue);
      this.$emit("checkbox-triggered", this.phone);
    },
  },
  computed: {
    isChecked() {
      return this.modelValue === 0;
    },
    shouldPreventUncheck() {
      return this.preventUncheck && this.isChecked;
    },
  },
};
</script>

<style scoped>
/* Add any additional styles here */
</style>
